import React, { memo } from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlangV2, setlang } from 'src/helper/getlang'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'
import {
  jumpToUser,
  jumpToWallet,
  closeWebview,
} from 'src/helper/webviewFun'
import config from 'src/core/config'
import VConsole from 'src/helper/vconsole'
import score from 'src/helper/score'
import { HTML5_FMT, relativeTimeThreshold } from 'moment'
import HistoryList from './history'
import Rule from './rule'
import RankDialog from './rank'

import UserList from './UserList'

const MemoSon = memo(() => {
  return <UserList lang={getlangV2()}></UserList>
})

const MemoImg = memo((props) => {
  return (
    <img
      className={`selectFruit fruit-box-select ${props.haveRes && 'fruit-box-select-pos' + props.fruitId}`}
      src="/img/activity/fruit/b2.png"
    />
  )
})

const MemoImg2 = memo((props) => {
  return (
    <img
      className={`selectFruit ${props.haveRes && 'fruit-box-select-pos' + props.his}`}
      src="/img/activity/fruit/b2.png"
    />
  )
})

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.fruitStore = this.props.store.register('activity/fruit')
  }
  state = {
    lang: langM.ar,
    betCoins: 100,
    stateTime: -1,
    canBet: false,
    showResult: false,
    timerJump: false,
    fruitId0: {
      number: 0,
      coins: 0
    },
    fruitId1: {
      number: 0,
      coins: 0
    },
    fruitId2: {
      number: 0,
      coins: 0
    },
    fruitId3: {
      number: 0,
      coins: 0
    },
    fruitId4: {
      number: 0,
      coins: 0
    },
    fruitId5: {
      number: 0,
      coins: 0
    },
    fruitId6: {
      number: 0,
      coins: 0
    },
    fruitId7: {
      number: 0,
      coins: 0
    },
    showPopRecharge: false,
    showResPop: true,
    isOpenHis: false,
    isRule: false,
    showPopMaxNum: false,
    showPopMaxCoins: false,
    weekTop1Avatarurl: '',
    isOpenRank: false,
    language:'en',
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, langM)
    console.log('language', language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    
    await this.fruitStore.GetUserInfoWeb(uid)
    await this.RunOnStart(uid)
  }

  submitBetTimer = 3
  submitBetData = []

  //初始化
  RunOnStart = async (uid) => {
    let { canBet, date, round, tsNow, tsZero } = await this.fruitStore.GetFruitTimeInfo()
    let FruitGameBetRecordCurrent = await this.fruitStore.getFruitGameBetRecordCurrent()
    if (FruitGameBetRecordCurrent.fruitId0) {
      this.setState({
        fruitId0: FruitGameBetRecordCurrent.fruitId0 || { number: 0, coins: 0 },
        fruitId1: FruitGameBetRecordCurrent.fruitId1 || { number: 0, coins: 0 },
        fruitId2: FruitGameBetRecordCurrent.fruitId2 || { number: 0, coins: 0 },
        fruitId3: FruitGameBetRecordCurrent.fruitId3 || { number: 0, coins: 0 },
        fruitId4: FruitGameBetRecordCurrent.fruitId4 || { number: 0, coins: 0 },
        fruitId5: FruitGameBetRecordCurrent.fruitId5 || { number: 0, coins: 0 },
        fruitId6: FruitGameBetRecordCurrent.fruitId6 || { number: 0, coins: 0 },
        fruitId7: FruitGameBetRecordCurrent.fruitId7 || { number: 0, coins: 0 },
        fruitId8: FruitGameBetRecordCurrent.fruitId8 || { number: 0, coins: 0 }
      })
    }
    // this.setState({weekTop1Avatarurl:await this.fruitStore.GetWeekTop1(7)})
    this.fruitStore.GetResult(false, 0)
    setInterval(async () => {
      
      if (this.submitBetTimer > 0) {
        this.submitBetTimer = this.submitBetTimer - 1
      }

      if (this.submitBetTimer == 1) {
        let res2 = this.fruitStore.GetFruitTimeInfo2()
        if (res2.tsNow > tsNow) {
          tsNow = res2.tsNow
        }
      }

      // let timestamp = Date.parse(new Date()) / 1000 //当前时间
      // if (timestamp - tsNow < 40 && timestamp - tsNow > -40) {
      //   tsNow = timestamp
      // }

      // tsNow = this.fruitStore.FixTime(tsNow)
      let leftTime = (tsNow - tsZero) % 45

      if (this.submitBetTimer == 0 || leftTime > 27) {
        this.submitBet() // 提交押注
        this.submitBetTimer = 3
      }

      if (leftTime == 0) {
        console.log('需要重新校对时间')
        this.resetBet()
        this.fruitStore.roundAdd()
      }

      if (leftTime == 30) {
        console.log('查看提交的数据')
        console.log(this.state)
        this.fruitStore.SetNewFruit(false)
      }

      if (leftTime == 38) {
        console.log('查看水果结果和自己的数据')
        this.submitBetData = [] //初始化提交的内容
        let userBetCoins =
          this.state.fruitId0.coins +
          this.state.fruitId1.coins +
          this.state.fruitId2.coins +
          this.state.fruitId3.coins +
          this.state.fruitId4.coins +
          this.state.fruitId5.coins +
          this.state.fruitId6.coins +
          this.state.fruitId7.coins
        this.fruitStore.GetResult(true, userBetCoins)
      }

      let canBet = false
      let showResult = false
      let timerJump = false
      let showPopMaxNum = false
      let showPopMaxCoins = false

      let t1 = 30 //0-24可以押注
      let t2 = 40 //25-34转动
      let t3 = 45 //35-39查看结果
      let ten = 0
      let single = 0

      if (leftTime <= t1) {
        single = (t1 - leftTime) % 10
        ten = (t1 - leftTime - single) / 10

        canBet = true
      } else if (leftTime <= t2) {
        single = (t2 - leftTime) % 10
        ten = (t2 - leftTime - ((t2 - leftTime) % 10)) / 10

        timerJump = true
      } else if (leftTime <= t3) {
        single = (t3 - leftTime) % 10
        ten = (t3 - leftTime - single) / 10

        showResult = true //显示结果
      }

      this.setState({
        stateTime: leftTime, //用来判断的时间
        ten: ten, //用来显示的时间
        single: single, //用来显示的时间
        canBet: canBet, //能否押注
        showResult: showResult, //显示结果页面
        timerJump: timerJump, //倒计时转盘
        uid
      })
      tsNow++
      // console.log('时间', this.state.stateTime, this.state.ten, this.state.single)
    }, 1000)

    this.fruitStore.GetRank(0)
  }

  // 提交押注
  submitBet = async () => {
    console.log('集合押注', this.submitBetData)
    if (this.submitBetData.length > 0) {
      console.log('可以提交', this.submitBetData)
      let d = this.submitBetData
      this.submitBetData = []
      // return

      // let betRes = await this.fruitStore.BetFruit([
      //   {
      //     fruitId: fruitId,
      //     number: 1,
      //     coins: this.state.betCoins
      //   }
      // ])

      let betRes = await this.fruitStore.BetFruit(d)
      console.log('提交', d)
      if (betRes == false) {
        console.log('返回错误', betRes, d)
        for (let i = 0; i < d.length; i++) {
          if (d[i].fruitId == 0 && this.state.fruitId0.number > 0 && this.state.fruitId0.coins > 0) {
            await this.setState({
              fruitId0: {
                number: this.state.fruitId0.number - 1,
                coins: this.state.fruitId0.coins - d[i].coins
              }
            })
          }

          if (d[i].fruitId == 1 && this.state.fruitId1.number > 0 && this.state.fruitId1.coins > 0) {
            await this.setState({
              fruitId1: {
                number: this.state.fruitId1.number - 1,
                coins: this.state.fruitId1.coins - d[i].coins
              }
            })
          }

          if (d[i].fruitId == 2 && this.state.fruitId2.number > 0 && this.state.fruitId2.coins > 0) {
            await this.setState({
              fruitId2: {
                number: this.state.fruitId2.number - 1,
                coins: this.state.fruitId2.coins - d[i].coins
              }
            })
          }

          if (d[i].fruitId == 3 && this.state.fruitId3.number > 0 && this.state.fruitId3.coins > 0) {
            await this.setState({
              fruitId3: {
                number: this.state.fruitId3.number - 1,
                coins: this.state.fruitId3.coins - d[i].coins
              }
            })
          }

          if (d[i].fruitId == 4 && this.state.fruitId4.number > 0 && this.state.fruitId4.coins > 0) {
            await this.setState({
              fruitId4: {
                number: this.state.fruitId4.number - 1,
                coins: this.state.fruitId4.coins - d[i].coins
              }
            })
          }

          if (d[i].fruitId == 5 && this.state.fruitId5.number > 0 && this.state.fruitId5.coins > 0) {
            await this.setState({
              fruitId5: {
                number: this.state.fruitId5.number - 1,
                coins: this.state.fruitId5.coins - d[i].coins
              }
            })
          }

          if (d[i].fruitId == 6 && this.state.fruitId6.number > 0 && this.state.fruitId6.coins > 0) {
            await this.setState({
              fruitId6: {
                number: this.state.fruitId6.number - 1,
                coins: this.state.fruitId6.coins - d[i].coins
              }
            })
          }

          if (d[i].fruitId == 7 && this.state.fruitId7.number > 0 && this.state.fruitId7.coins > 0) {
            await this.setState({
              fruitId7: {
                number: this.state.fruitId7.number - 1,
                coins: this.state.fruitId7.coins - d[i].coins
              }
            })
          }
        }
      }
    }

    console.log(this.state.fruitId0)
    console.log(this.state.fruitId1)
    console.log(this.state.fruitId2)
    console.log(this.state.fruitId3)
    console.log(this.state.fruitId4)
    console.log(this.state.fruitId5)
    console.log(this.state.fruitId6)
    console.log(this.state.fruitId7)
  }

  resetBet = async () => {
    this.setState({
      fruitId0: {
        number: 0,
        coins: 0
      },
      fruitId1: {
        number: 0,
        coins: 0
      },
      fruitId2: {
        number: 0,
        coins: 0
      },
      fruitId3: {
        number: 0,
        coins: 0
      },
      fruitId4: {
        number: 0,
        coins: 0
      },
      fruitId5: {
        number: 0,
        coins: 0
      },
      fruitId6: {
        number: 0,
        coins: 0
      },
      fruitId7: {
        number: 0,
        coins: 0
      }
    })
  }

  addBetReadyToSubmit = async (json) => {
    console.log('增加的内容', json)
    // if (this.state.stateTime>=30) {
    //   return
    // }

    let inArray = false
    if (this.submitBetData.length > 0) {
      for (let i = 0; i < this.submitBetData.length; i++) {
        if (this.submitBetData[i].fruitId == json.fruitId) {
          this.submitBetData[i].number++
          this.submitBetData[i].coins = this.submitBetData[i].coins + this.state.betCoins
          inArray = true
          break
        }
      }
    }

    if (inArray == false) {
      this.submitBetData.push(json)
    }

    console.log('准备提交的内容', this.submitBetData)
  }

  addBet = async (fruitId) => {
    if (this.state.stateTime >= 30) {
      return
    }
    let coins = this.state.betCoins
    if (this.state.canBet && coins > 0) {
      // this.submitBetTimer = 3 //先不要集体提交，这里会引起bug
      let { userInfo } = this.fruitStore.data
      let userBetCoins =
        this.state.betCoins +
        this.state.fruitId0.coins +
        this.state.fruitId1.coins +
        this.state.fruitId2.coins +
        this.state.fruitId3.coins +
        this.state.fruitId4.coins +
        this.state.fruitId5.coins +
        this.state.fruitId6.coins +
        this.state.fruitId7.coins
      if (userInfo.gold == 0 || userInfo.gold < userBetCoins) {
        //没有金币
        this.setState({
          showPopRecharge: true
        })
        console.log('不够金币')
        return
      }

      let BetNum = 0

      if (this.state.fruitId0.coins > 0) {
        BetNum++
      }
      if (this.state.fruitId1.coins > 0) {
        BetNum++
      }
      if (this.state.fruitId2.coins > 0) {
        BetNum++
      }
      if (this.state.fruitId3.coins > 0) {
        BetNum++
      }
      if (this.state.fruitId4.coins > 0) {
        BetNum++
      }
      if (this.state.fruitId5.coins > 0) {
        BetNum++
      }
      if (this.state.fruitId6.coins > 0) {
        BetNum++
      }
      if (this.state.fruitId7.coins > 0) {
        BetNum++
      }
      if (this.state[`fruitId${fruitId}`].coins == 0) {
        BetNum++
      }

      console.log('BetNum', BetNum)

      if (BetNum > 6) {
        BetNum = 0
        //没有金币
        this.setState({
          showPopMaxNum: true
        })
        console.log('不能押注超过6个水果')
        return
      }

      if (userBetCoins > 100000) {
        //没有金币
        this.setState({
          showPopMaxCoins: true
        })
        console.log('不能押注超过100k金币')
        return
      }

      if (fruitId == 0) {
        await this.setState({
          fruitId0: {
            number: this.state.fruitId0.number + 1,
            coins: this.state.fruitId0.coins + coins
          }
        })
        console.log(this.state.fruitId0)
      }

      if (fruitId == 1) {
        await this.setState({
          fruitId1: {
            number: this.state.fruitId1.number + 1,
            coins: this.state.fruitId1.coins + coins
          }
        })
        console.log(this.state.fruitId1)
      }

      if (fruitId == 2) {
        await this.setState({
          fruitId2: {
            number: this.state.fruitId2.number + 1,
            coins: this.state.fruitId2.coins + coins
          }
        })
        console.log(this.state.fruitId2)
      }

      if (fruitId == 3) {
        await this.setState({
          fruitId3: {
            number: this.state.fruitId3.number + 1,
            coins: this.state.fruitId3.coins + coins
          }
        })
        console.log(this.state.fruitId3)
      }

      if (fruitId == 4) {
        await this.setState({
          fruitId4: {
            number: this.state.fruitId4.number + 1,
            coins: this.state.fruitId4.coins + coins
          }
        })
        console.log(this.state.fruitId4)
      }

      if (fruitId == 5) {
        await this.setState({
          fruitId5: {
            number: this.state.fruitId5.number + 1,
            coins: this.state.fruitId5.coins + coins
          }
        })
        console.log(this.state.fruitId5)
      }

      if (fruitId == 6) {
        await this.setState({
          fruitId6: {
            number: this.state.fruitId6.number + 1,
            coins: this.state.fruitId6.coins + coins
          }
        })
        console.log(this.state.fruitId6)
      }

      if (fruitId == 7) {
        await this.setState({
          fruitId7: {
            number: this.state.fruitId7.number + 1,
            coins: this.state.fruitId7.coins + coins
          }
        })
        console.log(this.state.fruitId7)
      }

      //押注
      this.addBetReadyToSubmit({
        fruitId: fruitId,
        number: 1,
        coins: this.state.betCoins
      })
    }
  }

  componentDidMount() {
    setDocumentTitle('')
  }

  pressButton = async (i) => {
    if (this.state.canBet) {
      this.setState({
        betCoins: i
      })
    }
  }

  async jumpToWallet() {
    jumpToWallet(0)
  }

  history = (list) => {
    return (
      <div className={`history`}>
        <div className={`result`}>Result:</div>
        {list &&
          list.length > 0 &&
          list.map((item, index) => {
            return (
              <div className={`item`} key={index}>
                <img className={`fruit ${item == 0 ? '' : 'hide'}`} src={`/img/activity/fruit/afruit${item + 1}.png`} />
                <img className={`fruit ${item == 1 ? '' : 'hide'}`} src={`/img/activity/fruit/afruit${item + 1}.png`} />
                <img className={`fruit ${item == 2 ? '' : 'hide'}`} src={`/img/activity/fruit/afruit${item + 1}.png`} />
                <img className={`fruit ${item == 3 ? '' : 'hide'}`} src={`/img/activity/fruit/afruit${item + 1}.png`} />
                <img className={`fruit ${item == 4 ? '' : 'hide'}`} src={`/img/activity/fruit/afruit${item + 1}.png`} />
                <img className={`fruit ${item == 5 ? '' : 'hide'}`} src={`/img/activity/fruit/afruit${item + 1}.png`} />
                <img className={`fruit ${item == 6 ? '' : 'hide'}`} src={`/img/activity/fruit/afruit${item + 1}.png`} />
                <img className={`fruit ${item == 7 ? '' : 'hide'}`} src={`/img/activity/fruit/afruit${item + 1}.png`} />
              </div>
            )
          })}
      </div>
    )
  }

  maxNumFruit = () => {
    let { lang } = this.state
    return (
      <div className={`${this.state.showPopMaxNum == true ? 'maxNumFruit' : 'hide'}`}>
        <div className={`restart`}>{lang.maxFruit}</div>

        <div className={`btns`}>
          <div className={`btn`} onClick={this.CloseMaxNumFruit.bind(this)}>
            {lang.OK}
          </div>
        </div>
      </div>
    )
  }

  maxCoins = () => {
    let { lang } = this.state
    return (
      <div className={`${this.state.showPopMaxCoins == true ? 'maxNumFruit' : 'hide'}`}>
        <div className={`restart`}>{lang.maxGold}</div>

        <div className={`btns`}>
          <div className={`btn`} onClick={this.CloseMaxCoins.bind(this)}>
            {lang.OK}
          </div>
        </div>
      </div>
    )
  }

  noCoins = () => {
    let { lang } = this.state
    return (
      <div className={`${this.state.showPopRecharge == true ? 'PopRecharge' : 'hide'}`}>
        <div className={`restart`}>{lang.noMoney}</div>

        <div className={`btns`}>
          <div className={`btn`} onClick={this.ClosePopRecharge.bind(this)}>
            {lang.cancel}
          </div>
          <div className={`btn2`} onClick={() => this.jumpToWallet()}>
            {lang.submit}
          </div>
        </div>
      </div>
    )
  }

  resPop = (users, history, rewardCoins, round, slowNetwork) => {
    // console.log("slowNetwork 111111", slowNetwork)
    let { lang } = this.state
    if (slowNetwork) {
      return <div className={`${this.state.showResult == true ? 'resPop center' : 'hide'}`}>{lang.slowNetwork}</div>
    } else {
      return (
        <div className={`${this.state.showResult == true ? 'resPop' : 'hide'}`}>
          <div className="title">Round {round || 0}</div>
          <div className="fruit">
            {history && history.length > 0 && (
              <img className={`fruitP`} src={`/img/activity/fruit/afruit${history[0] + 1}.png`} />
            )}
            {history && history.length > 0 && (
              <img className={`fbg addRotate`} src="/img/activity/fruit/bg-ligth@2x.png" />
            )}
          </div>
          {rewardCoins > 0 ? (
            <div className="getCoins">
              <div>{lang.youGet.replace('AAA', rewardCoins)}</div>
              <img className={`coins`} src="https://img.chatie.live/app/source/gold.png" />
            </div>
          ) : (
            ''
          )}
          <div className="man-title">{users && users.length > 0 ? lang.Winner : lang.NoWinner}</div>
          <div className="man-item">
            {users &&
              users.map((item, index) => {
                return (
                  <div className="item" key={index}>
                    <div className={`item-pic ${'item-pic' + index}`}>
                      <img src={item.avatarurl} />
                    </div>
                    <div className="coins">
                      <div>{item.val}</div>
                      <img src="https://img.chatie.live/app/source/gold.png" />
                    </div>
                  </div>
                )
              })}
          </div>
        </div>
      )
    }
  }

  ClosePopRecharge = async () => {
    this.setState({
      showPopRecharge: !this.state.showPopRecharge
    })
  }

  CloseMaxNumFruit = async () => {
    this.setState({
      showPopMaxNum: !this.state.showPopMaxNum
    })
  }

  CloseMaxCoins = async () => {
    this.setState({
      showPopMaxCoins: !this.state.showPopMaxCoins
    })
  }

  async closeWebview() {
    closeWebview()
  }

  async openDialog(type) {
    if (type == 1) {
      this.setState({ isOpenHis: true, isOpenRank: false })
      await this.fruitStore.GetUserHistory({})
    } else if (type == 2) {
      this.setState({ isOpenHis: false, isOpenRank: true })
      await this.fruitStore.GetRank(0)
    }
  }

  render() {
    let {
      timerJump,
      lang,
      betCoins,
      canBet,
      fruitId0,
      fruitId1,
      fruitId2,
      fruitId3,
      fruitId4,
      fruitId5,
      fruitId6,
      fruitId7,
      fruitId8,
      showPopRecharge,
      isOpenHis,
      isRule,
      isOpenRank
    } = this.state
    let {
      userInfo,
      newFruit,
      result,
      history,
      notNetwork,
      users,
      rewardCoins,
      round,
      slowNetwork,
      weekTop1Avatarurl,
      top1Uid
    } = this.fruitStore.data
    let allCoin =
      userInfo.gold -
      this.state.fruitId0.coins -
      this.state.fruitId1.coins -
      this.state.fruitId2.coins -
      this.state.fruitId3.coins -
      this.state.fruitId4.coins -
      this.state.fruitId5.coins -
      this.state.fruitId6.coins -
      this.state.fruitId7.coins
    return (
      <div className={`fruitBody`}>
        <MemoSon />

        <img className={`light-r`} src="/img/app/gashapon/star.gif" />
        <img className={`light-l`} src="/img/activity/family/light.png" />
        <img onClick={() => this.openDialog(2)} className={`cup`} src="/img/activity/fruit/cup.png" />
        <img onClick={() => this.openDialog(1)} className={`record`} src="/img/activity/fruit/record.png" />
        <img
          onClick={() => this.setState({ isRule: true })}
          className={`question`}
          src="/img/activity/fruit/question.png"
        />
        <img className={`close`} src="/img/activity/fruit/close.png" onClick={() => this.closeWebview()} />

        <div className="bg bg-bgc"></div>
        <div className={`machine`}>
          <img
            onClick={() => this.jumpToWallet()}
            className={`goldCoins`}
            src="/img/activity/fruit/fruit_bt_goldbg@2x.png"
          />
          <img
            onClick={() => this.jumpToWallet()}
            className={`goldCoins2`}
            src="https://img.chatie.live/app/source/gold.png"
          />
          <div onClick={() => this.jumpToWallet()} className={`goldCoinsNum`}>
            {score(allCoin>0?allCoin:0)}
          </div>

          <img className={`roundBg`} src="/img/activity/fruit/round.png" />
          <div className={`round`}>Round: {round || 0}</div>

          <div className={`light fruit-light`}></div>

          <div className={`fruitbutton`}>
            {timerJump && (
              // <img
              //   className={`selectFruit fruit-box-select ${result && result.haveRes && 'fruit-box-select-pos' + result.fruitId}`}
              //   src="/img/activity/fruit/b2.png"
              // />
              <MemoImg haveRes={result && result.haveRes} fId={result.fruitId}></MemoImg>
            )}
            {this.state.showResult && notNetwork == false && history && history.length > 0 && (
              // <img
              //   className={`selectFruit ${result && result.haveRes && 'fruit-box-select-pos' + history[0]}`}
              //   src="/img/activity/fruit/b2.png"
              // />
              <MemoImg2 haveRes={result && result.haveRes} his={history[0]}></MemoImg2>
            )}

            <div className={`item`} onClick={this.addBet.bind(this, 0)}>
              <img className={`fruit`} src="/img/activity/fruit/afruit1.png" />
              <div className={`times`}>x5</div>
              <div className={`coins ${fruitId0.coins > 0 || timerJump ? '' : 'hide'}`}>
                {
                  <img
                    className={`${fruitId0.coins > 0 ? '' : 'hide'}`}
                    src="https://img.chatie.live/app/source/gold.png"
                  />
                }
                {fruitId0.coins > 0 && fruitId0.coins}
              </div>
            </div>
            <div className={`item`} onClick={this.addBet.bind(this, 1)}>
              <img className={`fruit`} src="/img/activity/fruit/afruit2.png" />
              <div className={`times`}>x5</div>
              <div className={`coins ${fruitId1.coins > 0 || timerJump ? '' : 'hide'}`}>
                {
                  <img
                    className={`${fruitId1.coins > 0 ? '' : 'hide'}`}
                    src="https://img.chatie.live/app/source/gold.png"
                  />
                }
                {fruitId1.coins > 0 && fruitId1.coins}
              </div>
            </div>
            <div className={`item`} onClick={this.addBet.bind(this, 2)}>
              <img className={`fruit`} src="/img/activity/fruit/afruit3.png" />
              <div className={`times`}>x5</div>
              <div className={`coins ${fruitId2.coins > 0 || timerJump ? '' : 'hide'}`}>
                {
                  <img
                    className={`${fruitId2.coins > 0 ? '' : 'hide'}`}
                    src="https://img.chatie.live/app/source/gold.png"
                  />
                }
                {fruitId2.coins > 0 && fruitId2.coins}
              </div>
            </div>
            <div className={`item`} onClick={this.addBet.bind(this, 7)}>
              <img className={`fruit`} src="/img/activity/fruit/afruit8.png" />
              <div className={`times`}>x40</div>
              <div className={`coins ${fruitId7.coins > 0 || timerJump ? '' : 'hide'}`}>
                {
                  <img
                    className={`${fruitId7.coins > 0 ? '' : 'hide'}`}
                    src="https://img.chatie.live/app/source/gold.png"
                  />
                }
                {fruitId7.coins > 0 && fruitId7.coins}
              </div>
            </div>
            <div className={`item fruit-time`}>
              <div className={`numberTime fruit-timer-num${this.state.ten}`}></div>
              <div className={`numberTime fruit-timer-num${this.state.single}`}></div>
            </div>
            <div className={`item`} onClick={this.addBet.bind(this, 3)}>
              <img className={`fruit`} src="/img/activity/fruit/afruit4.png" />
              <div className={`times`}>x5</div>
              <div className={`coins ${fruitId3.coins > 0 || timerJump ? '' : 'hide'}`}>
                {
                  <img
                    className={`${fruitId3.coins > 0 ? '' : 'hide'}`}
                    src="https://img.chatie.live/app/source/gold.png"
                  />
                }
                {fruitId3.coins > 0 && fruitId3.coins}
              </div>
            </div>
            <div className={`item`} onClick={this.addBet.bind(this, 6)}>
              <img className={`fruit`} src="/img/activity/fruit/afruit7.png" />
              <div className={`times`}>x25</div>
              <div className={`coins ${fruitId6.coins > 0 || timerJump ? '' : 'hide'}`}>
                {
                  <img
                    className={`${fruitId6.coins > 0 ? '' : 'hide'}`}
                    src="https://img.chatie.live/app/source/gold.png"
                  />
                }
                {fruitId6.coins > 0 && fruitId6.coins}
              </div>
            </div>
            <div className={`item`} onClick={this.addBet.bind(this, 5)}>
              <img className={`fruit`} src="/img/activity/fruit/afruit6.png" />
              <div className={`times`}>x15</div>
              <div className={`coins ${fruitId5.coins > 0 || timerJump ? '' : 'hide'}`}>
                {
                  <img
                    className={`${fruitId5.coins > 0 ? '' : 'hide'}`}
                    src="https://img.chatie.live/app/source/gold.png"
                  />
                }
                {fruitId5.coins > 0 && fruitId5.coins}
              </div>
            </div>
            <div className={`item`} onClick={this.addBet.bind(this, 4)}>
              <img className={`fruit`} src="/img/activity/fruit/afruit5.png" />
              <div className={`times`}>x10</div>
              <div className={`coins ${fruitId4.coins > 0 || timerJump ? '' : 'hide'}`}>
                {
                  <img
                    className={`${fruitId4.coins > 0 ? '' : 'hide'}`}
                    src="https://img.chatie.live/app/source/gold.png"
                  />
                }
                {fruitId4.coins > 0 && fruitId4.coins}
              </div>
            </div>
          </div>

          <img className={`topbg`} src="/img/activity/fruit/topbg.png" />
          <img className={`topbg2`} src="/img/activity/fruit/topbg2.png" />
          <img
            className={`topbg25`}
            src={weekTop1Avatarurl ? weekTop1Avatarurl : 'https://img.chatie.live/app/man.jpg?t=6'}
          />
          <img
            className={`topbg3`}
            onClick={() => {
              jumpToUser(top1Uid && top1Uid)
            }}
            src="/img/activity/fruit/topbg3.png"
          />

          <div className={`selectButton`}>
            <div
              className={`item ${betCoins == 10000 && canBet && 'active'} ${!canBet && 'gray'}`}
              onClick={this.pressButton.bind(this, 10000)}
            >
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/1.png" />
              </div>
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/0.png" />
              </div>
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/0.png" />
              </div>
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/0.png" />
              </div>
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/0.png" />
              </div>
            </div>
            <div
              className={`item ${betCoins == 1000 && canBet && 'active'} ${!canBet && 'gray'}`}
              onClick={this.pressButton.bind(this, 1000)}
            >
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/1.png" />
              </div>
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/0.png" />
              </div>
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/0.png" />
              </div>
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/0.png" />
              </div>
            </div>
            <div
              className={`item ${betCoins == 500 && canBet && 'active'} ${!canBet && 'gray'}`}
              onClick={this.pressButton.bind(this, 500)}
            >
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/5.png" />
              </div>
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/0.png" />
              </div>
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/0.png" />
              </div>
            </div>
            <div
              className={`item ${betCoins == 100 && canBet && 'active'} ${!canBet && 'gray'}`}
              onClick={this.pressButton.bind(this, 100)}
            >
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/1.png" />
              </div>
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/0.png" />
              </div>
              <div className={`num`}>
                <img className={`numpic`} src="/img/activity/fruit/0.png" />
              </div>
            </div>
          </div>

          {this.history(history)}

          <RankDialog
            isOpenRank={isOpenRank}
            lang={lang}
            onCloseRank={() => this.setState({ isOpenRank: false })}
            store={this.fruitStore.data}
          />

          <HistoryList
            isOpenHis={isOpenHis}
            lang={lang}
            onCloseHis={() => this.setState({ isOpenHis: false })}
            historyInfo={this.fruitStore.data.userHistory}
            uid={this.fruitStore.data.uid}
          />

          <Rule
            isRule={isRule}
            lang={lang}
            onCloseRule={() => this.setState({ isRule: false })}
            store={this.fruitStore.data}
          />

          {history && newFruit && history.length > 0 && <img className={`new`} src="/img/activity/fruit/now_new.png" />}
        </div>
        {this.resPop(users, history, rewardCoins, round, slowNetwork)}
        {/* {(notNetwork==true) && <div className={`notNetwork`}>{lang.notNetwork}</div>} */}
        {/* {(notNetwork==true || showPopRecharge==true) && <div className={`notNetwork-mask`}></div>} */}
        {this.noCoins()}
        {this.maxNumFruit()}
        {this.maxCoins()}

        <div className={`hide`}>
          <img src="/img/activity/fruit/t0.png" />
          <img src="/img/activity/fruit/t1.png" />
          <img src="/img/activity/fruit/t2.png" />
          <img src="/img/activity/fruit/t3.png" />
          <img src="/img/activity/fruit/t4.png" />
          <img src="/img/activity/fruit/t5.png" />
          <img src="/img/activity/fruit/t6.png" />
          <img src="/img/activity/fruit/t7.png" />
          <img src="/img/activity/fruit/t8.png" />
          <img src="/img/activity/fruit/t9.png" />
          <img src="/img/activity/fruit/b2.png" />
          <img src="/img/activity/fruit/afruit1.png" />
          <img src="/img/activity/fruit/afruit2.png" />
          <img src="/img/activity/fruit/afruit3.png" />
          <img src="/img/activity/fruit/afruit4.png" />
          <img src="/img/activity/fruit/afruit5.png" />
          <img src="/img/activity/fruit/afruit6.png" />
          <img src="/img/activity/fruit/afruit7.png" />
          <img src="/img/activity/fruit/afruit8.png" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/fruit1103/index.js